/**
 * Created by kaiyan2 on 1/18/2017.
 */
import React from 'react';
import {generateInfoCard, generate} from "Common/utility/infoCard";

import axios from "axios";

class CreationCarousel extends React.Component {
  constructor(props) {
    super(props);

    this.itemSize = 0;
    this.itemWidth = 360;
    this.itemShow = 3;
    this.animating = false;
    this.xPosition = 0;
    this.state = {
      items: null
    };
    this.DevNetCreationAPI = PubHub.DevNetCreationAPI;
    this.handleClickPrevious = this.handleClickPrevious.bind(this);
    this.handleClickNext = this.handleClickNext.bind(this);
    this.renderCreationItem = this.renderCreationItem.bind(this);
    this.renderClonedCreateionItem = this.renderClonedCreateionItem.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.getCreationData = this.getCreationData.bind(this);
    this.generateItem = this.generateItem.bind(this);
    this.panesRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.config) {
      this.getCreationData(this.props.config);
    }
    this.panesRef.current.addEventListener("transitionend", this.handleTransitionEnd, false);
  }

  componentDidUpdate(prevProps) {
    if (this.props.config && this.props.config != prevProps.config) {
      this.getCreationData(this.props.config);
    }
  }

  componentWillUnmount() {
    this.panesRef.current.removeEventListener("transitionend", this.handleTransitionEnd);
  }

  getCreationData(config) {
    const creationIdSet = config.querySelectorAll("creationID");
    for (let i = 0; i < creationIdSet.length; i++) {
      const creationID = creationIdSet[i].innerHTML.trim();
      axios.get(`${this.DevNetCreationAPI}/${creationID}.json`)
        .then(this.generateItem);
    }
  }

  generateItem(response) {
    if (!response) {
      return
    }

    const data = response.data;
    let item = {
      "link": {
        "text": data.title,
        "url": `https://creations.devnetcloud.com/detail?cid=1e4a9f92-deea-11e7-9d2f-aed03b${data.id}`,
        "target": "_blank"
      },
      "subtitle": data.answers[6].answer,
      "description": data.description,
      "image": {
        "src": data.answers[35].downloadLink ? data.answers[35].downloadLink : "https://developer.cisco.com/site/devnetcreations/asset/img/tile_default.jpg",
        "url": `https://creations.devnetcloud.com/detail?cid=1e4a9f92-deea-11e7-9d2f-aed03b${data.id}`,
        "target": "_blank"
      },
      "tags": data.answers[2].answer.slice(1, data.answers[2].answer.length - 1)
    };
    let items = this.state.items;
    if (!items) {
      items = [item];
    } else {
      items.push(item);
    }
    this.setState({
      items
    });

  }


  move(step) {
    if (this.animating)
      return;

    this.xPosition += step;

    const {panes} = this.refs;

    panes.classList.remove("transition");

    if (this.xPosition < 0) {
      panes.classList.remove("transition");
      panes.style.transform = `translate3d(${this.itemSize * this.itemWidth * -1}px,0,0)`;

      this.xPosition = this.itemSize - 1;

    } else if (this.xPosition > this.itemSize) {
      panes.classList.remove("transition");
      panes.style.transform = `translate3d(0px,0,0)`;
      this.xPosition = 1;
    }

    if (this._transitionTimer) {
      clearTimeout(this._transitionTimer);
    }


    this._transitionTimer = setTimeout(() => {
      this.animating = true;
      panes.classList.add("transition");
      panes.style.transform = `translate3d(${this.xPosition * this.itemWidth * -1}px,0,0)`;
    }, 5);


  }

  handleClickPrevious() {
    this.move(-1);
  }

  handleClickNext() {
    this.move(1);
  }


  renderCreationItem(item, index, array, clone = false) {
    const elements = generateInfoCard(item, this.props.location, this.props.type);
    return (
      <div key={index}
           className={`pubhub-creation-carousel-item col-lg-4 col-md-6 col-sm-12 col-12 ${clone ? "clone" : ""}`}
           style={{width: `${this.itemWidth}px`}}>
        <div className="pubhub-creation-carousel-item-content">
          <span data-track-name="creationCard:thumbnail"
                data-track-value={item.link.text} >
             {elements.image}
          </span>

          <div className="pubhub-creation-carousel-item-text-card">
            <span data-track-name="creationCard:link"
                  data-track-value={item.link.text} >
            {elements.link}
            </span>
            {elements.subtitle}
            {elements.description}
            <div className="pubhub-creation-carousel-item-text-card-tags">
              {item.tags}
            </div>
          </div>
        </div>

      </div>
    )
  }

  renderClonedCreateionItem(item, index, array) {
    return this.renderCreationItem(item, index + this.itemSize, array, true);
  }

  handleTransitionEnd() {
    this.animating = false;
  }


  render() {
    const {config, location} = this.props;
    if (!config) {
      return <span className="pubhub-loading"/>
    }

    const title = config.queryChild("title").innerHTML.trim();
    const xmlSubtitle = config.queryChild("subtitle");
    const subtitle = xmlSubtitle ? xmlSubtitle.innerHTML.trim() : '';
    let queryItems = Array.from(config.querySelectorAll("creationID"));

    let leftPointer = null;
    let rightPointer = null;

    let paneStyle = {};
    let stageStyle = {};
    let content = <span className="pubhub-loading"/>;

    if (this.state.items && this.state.items.length == queryItems.length) {
      if (this.state.items.length > 0) {
        //inorder let carousel reversible example [1 2 3 4 1 2 3]
        const items = [...this.state.items, ...this.state.items.slice(0, this.itemShow)];
        this.itemSize = this.state.items.length;

        const width = items.length * this.itemWidth;
        //debugger;
        paneStyle = {
          width: `${width}px`,
        };
        stageStyle = {
          width: `${this.itemShow * this.itemWidth}px`,
        };


        let renderedClonedItems = null;

        if (this.state.items.length > this.itemShow) {
          leftPointer = (
            <div className="col-auto">
              <span
                className="pubhub-creation-carousel-container-pointer pubhub-creation-carousel-container-pointer-left"
                onClick={this.handleClickPrevious}/>
            </div>
          );
          rightPointer = (
            <div className="col-auto ">
              <span
                className="pubhub-creation-carousel-container-pointer pubhub-creation-carousel-container-pointer-right"
                onClick={this.handleClickNext}/>
            </div>
          );
          renderedClonedItems = this.state.items.slice(0, this.itemShow).map(this.renderClonedCreateionItem);
        }
        const renderedItems = this.state.items.map(this.renderCreationItem);
        content = (
          <div className="row">
            {renderedItems}
            {renderedClonedItems}
          </div>
        );
      } else {
        content = <p>No Creation</p>;
      }
    }
    return (
      <div className="pubhub-creation-carousel pubhub-widget">
        <div className="container">
          <div className="pubhub-creation-carousel-title">{title}</div>
          {
            subtitle ? (<div className="pubhub-creation-carousel-subtitle">{subtitle}</div>) : null
          }
          <div
            className="row flex-nowrap pubhub-creation-carousel-container align-items-top justify-content-center">
            {leftPointer}
            <div className="pubhub-creation-carousel-stage col-auto" style={stageStyle}>
              <div className="col-12 pubhub-creation-carousel-panes" ref={this.panesRef} style={paneStyle}>
                {content}
              </div>
            </div>
            {rightPointer}
          </div>
        </div>
      </div>
    )
  }
}

export default CreationCarousel;
